module.exports = __webpack_public_path__ + "media/img/kanban/kanban-2-0dfcd11a7797b0aba041b23872b1269b.jpg";